<template>

  <div>
    <div class="row">
      <div class="col-sm-6">
        <form @submit.prevent="productSearch" class="search noborder">
          <p v-show="noProductsMessage" style="color: red">No products found</p>
          <input placeholder="Search product" v-model="productCode" class="input form-search"/>
          <button class="button button--search">Search</button>
        </form>
      </div>
    </div>

    <div v-show="products">
      <table class="table">
        <thead>
        <tr>
          <th class="table__header">Product</th>
          <th class="table__header">Description</th>
          <th class="table__header">Type</th>
          <th class="table__header small">Select</th>
        </tr>
        </thead>
        <tbody>
        <tr :class="{ active: product.active}" v-for="product in products">
          <td class="table__col">{{ product.code }}</td>
          <td class="table__col">{{ product.description }}</td>
          <td class="table__col">{{ product.certType }}</td>
          <td class="table__col">
            <button class="button button--search" style="position: inherit" :disabled="isDisabled" v-on:click="setSelectedProduct(product)">Select</button>
          </td>
        </tr>
        </tbody>
      </table>
      <hr>
    </div>

  </div>


</template>

<script>

import axios from 'axios';

export default {
  name: 'AppProductSearch',
  components: {
  },
  props: [
    'enabled'
  ],
  data() {
    return {
      products: null,
      productCode: null,
      selectedProduct: null,
      noProductsMessage : false
    }
  },
  computed:{
    isDisabled() {
      return !(this.enabled === true || this.enabled === undefined);
    }
  },
  methods: {
    productSearch() {
      const url = `/products/search/${this.productCode}`;

      axios
        .get(url)
        .then((products) => {

          this.noProductsMessage = false;

          products.data.forEach(product => product.active = false)

          this.products = products.data;
        })
        .catch((e) => {
         this.noProductsMessage = true;
         this.products = null;
        });
    },
    setSelectedProduct(product) {
      this.products.forEach(product => product.active = false)
      product.active = true;
      this.selectedProduct = product;
    }
  }
}
</script>
